module.exports = __webpack_public_path__ + "media/images/icon_user1-05aa62ab9e01f6c32d91dcc1607e18fd.png";